import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Utilities } from 'src/app/models/utilities';
import { AppCoreService } from 'src/app/services/app-core.service';
import { VendorService } from 'src/app/services/vendor.service';
import { ZoneService } from "src/app/services/zone.service";

@Component({
  selector: 'app-zoneperiod',
  templateUrl: './zoneperiod.component.html',
  styleUrls: ['./zoneperiod.component.scss']
})
export class ZoneperiodComponent implements AfterViewInit {
  modelZonePeriodForm: FormGroup;
  @Input() public cell: any;
  isFormSubmitted = false;
  vendorList: any = [];
  currentDate: any;
  useEnterKey: any;

  constructor(
    private appCoreService: AppCoreService,
    public activeModal: NgbActiveModal,
    private ngxLoaderService: NgxUiLoaderService,
    private _fb: FormBuilder,
    private zoneService: ZoneService,
    private vendorService: VendorService,
    private utilities: Utilities
  ) { }

  async ngOnInit() {
    this.modelZonePeriodForm = this._fb.group({
      ddlVendor: [{ disabled: true, value: null }],
      txtFromDate: [{ disabled: true, value: null }],
      txtToDate: [null],
    });
    this.currentDate = this.utilities.FormatDateWithTime().dateString;
    await this.bindVendor();
    this.getVendorRecoDetails();

    // const userData = this.appCoreService.GetUserData();
    // this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
  }

  ngAfterViewInit(): void {
    this.useEnterKey ? this.utilities.focusFirstElement(this.modelZonePeriodForm) : null;
  }

  async bindVendor() {
    this.vendorService.GetAll().subscribe((res) => {
      this.vendorList = res?.data ? res.data : null;
    })
  }

  getVendorRecoDetails() {
    try {
      this.ngxLoaderService.start();
      this.zoneService.GetPeriodDetailbyId(this.cell).subscribe(res => {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          this.modelZonePeriodForm.get('ddlVendor').setValue(res.data[0]?.vendorid);
          this.modelZonePeriodForm.get('txtFromDate').setValue(res.data[0]?.fromdate);
          this.modelZonePeriodForm.get('txtToDate').setValue(this.utilities.FormatDateWithTime(0, res.data[0]?.todate).dateString);
        }
      })
    } catch (err: any) {
      this.ngxLoaderService.stop();
    }
  }

  updateZonePeriodDetails(): void {

    let reqObj = {
      id: this.cell,
      toDate: this.modelZonePeriodForm.get('txtToDate').value
    }


    if (this.modelZonePeriodForm.valid) {
      this.ngxLoaderService.start();
      this.zoneService.UpdateZonePeriodDetail(reqObj).subscribe(res => {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          this.appCoreService.showMessage('Detail Updated Successfully.', 'Success', 'success');
          this.modelZonePeriodForm.reset();
          this.activeModal.close('Save Click');
        }
      })

      this.ngxLoaderService.stop();
    }
  }

  reset() {
    this.modelZonePeriodForm.reset();
    this.activeModal.close('Cross click');
  }

}
